export const screenerKeys = {
  all: ["screener"] as const,
  prefs: {
    byScope: (scope: "stocks" | "etf") =>
      [...screenerKeys.all, "prefs", scope] as const,
  },
};
